<template>
  <div :class="['card', bShowCard ? '' : 'onCard']">
    <div class="logo">
      <img src="@/assets/images/antV2/scheme/logo.png" alt="" />
    </div>
    <div class="title">
      <img src="@/assets/images/antV2/scheme/title.png" alt="" />
    </div>
    <div class="case">
      <img src="@/assets/images/antV2/scheme/made_icon.png" alt="" />
    </div>
    <div class="address">{{ reporInfo.address ? reporInfo.address : "" }}</div>
    <div class="btn" @click="subimt">
      <img src="@/assets/images/antV2/scheme/read_icon.png" alt="" />
    </div>
    <div class="card_warp" v-if="bCard">
      <div class="card_info">
        <div>VIP专属高级服务顾问</div>
        <div>{{reporInfo.card.name+" : "+reporInfo.card.phone}}</div>
      </div>
      <div
        class="card_btn"
        @click="copy"
        :data-clipboard-text="reporInfo.card.phone"
        id="express_info_right"
      >
        点击复制
      </div>
    </div>
    <div class="agree_btn" v-if="bAgree">
      <div class="check_btn" @click="getCheck">
        <img
          v-if="bChecked"
          src="@/assets/images/antV2/scheme/noclick_icon.png"
          alt=""
        />
        <img v-else src="@/assets/images/antV2/scheme/click_icon.png" alt="" />
      </div>
      <div @click="getText">同意《A.O.史密斯艾暖通小程序隐私条款协议》</div>
    </div>
    <!-- 隐私协议 -->
    <div class="agree" v-if="bText" @click="bText = false">
      <div class="agree_warp">
        <div class="agree_title">{{ objSmcode.title }}</div>
        <div class="content_agree">
          <div v-html="objSmcode.content"></div>
        </div>
        <!-- <div class="consent">
          <input type="checkbox" />
          我同意上述隐私协议
        </div>
        <div class="btn" @click="subimt">确定</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import detail from "@/js/detail.js";
import { Toast } from "mint-ui";
export default {
  props: {
    bCard:{
      type:Boolean,
      default:false,
    },
    reporInfo: {
      type: Object,
      default: false,
    },
    bShowCard: {
      type: Boolean,
      default: false,
    },
    objSmcode: {
      type: Object,
      default: false,
    },
    bAgree: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bChecked: true,
      bText: false,
    };
  },
  mounted() {
    if (!this.bAgree) {
      this.bChecked = false;
    }
    // console.log("子标签", this.bAgree);
  },
  methods: {
    //呼出协议
    getText() {
      this.bText = !this.bText;
    },
    getCheck(e) {
      this.bChecked = !this.bChecked;
      // console.log(e.target.checked);
    },
    //点击同意隐私条款
    subimt() {
      if (this.bChecked) {
        Toast({
          message: "请勾选下方A.O.史密斯小程序隐私政策",
          duration: 1200,
        });
      } else if (!this.bChecked) {
        detail.getAccept().then((res) => {
          this.$emit("update:bShowCard", false);
        });
      }
    },
    //点击名片消失
    goCase() {
      this.$emit("update:bShowCard", false);
    },
    //复制文本
    copy() {
      let clipboard = new this.$clipboard("#express_info_right");
      let that = this;
      clipboard.on("success", function () {
        Toast({
          message: "复制成功",
          duration: 1200,
        });
        clipboard.destroy();
      });
      clipboard.on("error", function () {
        Toast({
          message: "复制失败",
          duration: 1200,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.agree {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.637);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .agree_warp {
    width: 80%;
    height: calc(100vh - 100px);
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .agree_title {
      font-weight: 700;
      font-size: 38px;
      text-align: center;
      margin-bottom: 20px;
    }
    .content_agree {
      width: 100%;
      height: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
        color: transparent !important;
        display: none;
      }
    }
    .consent {
      display: flex;
      align-items: center;
      margin-top: 20px;
      input {
        width: 40px;
        height: 40px;
        -webkit-appearance: button !important;
        margin-right: 10px;
      }
    }
    .btn {
      width: 450px;
      height: 85px;
      background-color: #023f88;
      border-radius: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      color: #fff;
      margin: 20px auto 0;
    }
  }
}
.noCard {
  display: none;
}
.onCard {
  animation: noantinpyt 0.5s forwards;
}
.card {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9;
  background: url(~@/assets/images/antV2/scheme/bg.png) no-repeat center/100%;
  .logo {
    position: absolute;
    top: 73px;
    right: 60px;
    width: 200px;
    img {
      width: 100%;
    }
  }
  .title {
    width: 619px;
    text-align: center;
    font-size: 55px;
    color: #fff;
    margin-top: 190px;
    margin-left: 55px;
    img {
      width: 100%;
    }
  }
  .address {
    width: 100%;
    font-size: 25px;
    color: #b8babd;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: "";
      display: inline-block;
      width: 14px;
      height: 20px;
      background: url(~@/assets/images/antV2/scheme/addresstwo_icon.png)
        no-repeat center/100% 100%;
      margin-right: 10px;
      margin-top: 3px;
    }
  }
  .case {
    width: 418px;
    font-size: 50px;
    color: #fff;
    text-align: center;
    // margin-top: 30px;
    margin: 100px auto 0;
    img {
      width: 100%;
    }
  }
  .btn {
    margin: 79px auto 0;
    width: 339px;
    // height: 88px;
    border-radius: 44px;
    // border: solid 3px #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #ffffff;
    img {
      width: 100%;
    }
  }
  .card_warp {
    width: 639px;
    height: 159px;
    // background-color: #ffffff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px;
    box-sizing: border-box;
    margin: 100px auto 0;
    border: 2px solid #8b807b;
    background: url(~@/assets/images/antV2/scheme/card_bk.png) no-repeat
      center/100% 100%;
    .card_info {
      div:first-child {
        font-size: 30px;
        color: #e7d1a0;
      }
      div:last-child {
        margin-top: 10px;
        font-size: 32px;
        color: #fff;
        display: flex;
        align-items: center;
      }
    }
    .card_btn {
      width: 149px;
      height: 45px;
      background-image: linear-gradient(90deg, #e0c598 56%, #ddcb9d 100%),
        linear-gradient(#e7d1a0, #e7d1a0);
      border-radius: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #041019;
      font-size: 27px;
      box-shadow: 0px 6px 19px 0px rgba(0, 0, 0, 0.49);
    }
  }
}
.agree_btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  margin-top: 37px;
  .check_btn {
    width: 22px;
    height: 22px;
    margin-right: 11px;
    img {
      width: 22px;
      // height: 22px;
    }
  }
}
@keyframes noantinpyt {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
</style>